
import { Clock, Users, Target } from "lucide-react";
import AnimatedCard from "@/components/AnimatedCard";
import { Button } from "@/components/ui/button";

const SelfPacedLearning = () => {
  return (
    <section className="py-16 md:py-24 px-6 relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-primary/10 rounded-full filter blur-[80px]"></div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="flex-1 order-1">
            <div className="grid grid-cols-1 gap-6">
              <AnimatedCard animation="slide-in-left" delay={0} className="p-5 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-white/5">
                    <Clock className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Self-Paced Learning</h3>
                    <p className="text-white/70">10-minute learning modules that fit into your team's schedule without disrupting daily operations.</p>
                  </div>
                </div>
              </AnimatedCard>
              
              <AnimatedCard animation="slide-in-left" delay={200} className="p-5 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-white/5">
                    <Users className="h-6 w-6 text-blue-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Organization-Wide</h3>
                    <p className="text-white/70">Tailored content for all team members, from legal assistants to partners, ensuring everyone develops relevant AI skills.</p>
                  </div>
                </div>
              </AnimatedCard>
              
              <AnimatedCard animation="slide-in-left" delay={400} className="p-5 backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl">
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-xl bg-white/5">
                    <Target className="h-6 w-6 text-purple-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Customized Curriculum</h3>
                    <p className="text-white/70">Programs designed specifically for your firm's practice areas, client base, and strategic priorities.</p>
                  </div>
                </div>
              </AnimatedCard>
            </div>
          </div>
          
          <div className="flex-1 order-2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Effective Self-Paced Learning Modules for the Entire Organization
            </h2>
            <p className="text-lg text-white/80 mb-4 leading-relaxed">
              AI education and training benefits legal teams and professionals at every level, from assistants to seasoned attorneys.
            </p>
            <p className="text-lg text-white/80 mb-4 leading-relaxed">
              Docket Labs makes it easy for teams to learn the essentials and get aligned on AI without disrupting the workload. Our education program is broken up into 10-minute, self-paced learning modules that team members complete with small amounts of idle time over the course of a few weeks.
            </p>
            <p className="text-lg text-white/80 mb-6 leading-relaxed">
              We work with team leaders to design a curriculum with modules selected and tailored to your firm's practice area and priorities.
            </p>
            
            <div className="mt-4">
              <Button variant="default" size="lg" className="bg-primary text-white">
                Request Curriculum Design
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SelfPacedLearning;
